const bcrypt = require('bcryptjs');
const saltRounds = 12;

export async function hashPassword(password) {
    try {
        const hash = await bcrypt.hash(password, saltRounds);
        console.log(hash);
        return hash;
    } catch (error) {
        throw new Error('Error al encriptar la contraseña: ' + error.message);
    }
};

export async function verifyPassword(passwordIngresada, contrasenaEncriptada) {
    try {
        return await bcrypt.compare(passwordIngresada, contrasenaEncriptada);
    } catch (error) {
        console.error('Error al verificar la contraseña:', error);
        return false;
    }
};